import * as React from "react";
import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import getEventTypeCategories from "search/contexts/api/eventTypeCategories";
import useLicenseCheck from "license/useLicenseCheck";
import { defaultOnError } from "util/conditional/onError";
import MessageSummaryTemplateContext from "./MessageSummaryTemplateContext";
export default function MessageSummaryTemplateProvider({ children }) {
  const {
    security: { isValid: isValidSecurityLicense }
  } = useLicenseCheck();
  const {
    isLoading,
    isError,
    error,
    data: eventTypeCategories
  } = useQuery({
    queryKey: ["eventTypeCategories"],
    queryFn: () => defaultOnError(getEventTypeCategories(), "Error fetching event categories"),
    enabled: isValidSecurityLicense
  });
  const contextValue = useMemo(
    () => ({
      isLoading,
      isError,
      error,
      eventTypeCategories
    }),
    [isLoading, isError, error, eventTypeCategories]
  );
  return /* @__PURE__ */ React.createElement(MessageSummaryTemplateContext.Provider, { value: contextValue }, children);
}
